/**
 * SportTabs - Componente Presentacional
 * 
 * Componente que renderiza una fila de tabs para filtrar ligas por deporte.
 * Extrae automáticamente todos los sports únicos del array de ligas.
 * El tab "Todos" muestra todas las ligas sin filtro.
 * 
 * @component
 * @param {Object} props - Props del componente
 * @param {Array} props.leagues - Array de ligas con campo sport
 *   Estructura: { id, name, sport, ... }
 * @param {string} props.activeSport - Sport actualmente seleccionado o 'all'
 * @param {Function} props.onSportChange - Callback ejecutado al cambiar de tab
 *   Recibe el sport (string) o 'all' como parámetro
 * @returns {JSX.Element} Contenedor con tabs de sports
 * 
 * @example
 * const leagues = [
 *   { id: '1', name: 'Liga MX', sport: 'football' },
 *   { id: '2', name: 'NBA', sport: 'basketball' },
 *   { id: '3', name: 'Premier', sport: 'football' }
 * ];
 * 
 * const [activeSport, setActiveSport] = useState('all');
 * 
 * <SportTabs
 *   leagues={leagues}
 *   activeSport={activeSport}
 *   onSportChange={setActiveSport}
 * />
 * 
 * Características:
 * - Incluye tab "Todos" por defecto
 * - Extrae sports únicos automáticamente
 * - Ordena los sports alfabéticamente
 * - Tab activo tiene clase 'active' y fondo destacado
 * - Estilos responsivos
 */

export default function SportTabs({ leagues, activeSport, onSportChange }) {
  // Extraer sports únicos del array de ligas
  const uniqueSports = [...new Set(leagues.map(league => league.sport))].sort();

  return (
    <div className="sport-tabs-container">
      <div className="sport-tabs">
        <button
          className={`sport-tab ${activeSport === 'all' ? 'active' : ''}`}
          onClick={() => onSportChange('all')}
        >
          Todos
        </button>
        {uniqueSports.map(sport => (
          <button
            key={sport}
            className={`sport-tab ${activeSport === sport ? 'active' : ''}`}
            onClick={() => onSportChange(sport)}
          >
            {sport.charAt(0).toUpperCase() + sport.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
}
